import { WSButton, WSElement, WSText } from "@wingspanhq/fe-component-library";
import { Invoice } from "@wingspanhq/wingspan-api-sdk";
import { queriesWorkItems, queriesWorkLogs } from "@query";
import { useHistory } from "react-router-dom";
import { routeHelpersWorkLogPayeeDetails } from "../../modules/WorkLogs/paths";

type Props = {
  invoice: Invoice;
};

export const InvoiceWorkLog: React.FC<Props> = ({ invoice }) => {
  const history = useHistory();

  const workItemId = invoice?.lineItems?.[0]?.metadata?.workItemId as
    | string
    | undefined;

  const queryWorkItem = queriesWorkItems.getWorkItem.useQuery(
    { workItemId: workItemId ?? "" },
    { enabled: !!workItemId }
  );

  const workLogId = queryWorkItem.data?.workLogId;

  const queryWorkLog = queriesWorkLogs.getWorkLog.useQuery(
    { workLogId: workLogId ?? "" },
    { enabled: !!workLogId }
  );

  if (!workLogId || !queryWorkLog.data?.workLogNumber) {
    return null;
  }

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray500">
        Created from work log{" "}
        <WSButton.Link
          onClick={() =>
            history.push(
              routeHelpersWorkLogPayeeDetails.createLocationObject({
                workLogId
              })
            )
          }
        >
          #{queryWorkLog.data.workLogNumber}
        </WSButton.Link>
      </WSText.ParagraphSm>
      <WSButton.Link
        mt="M"
        onClick={() =>
          history.push(
            routeHelpersWorkLogPayeeDetails.createLocationObject({ workLogId })
          )
        }
        rightIcon="chevron-right"
      >
        View work log
      </WSButton.Link>
    </WSElement>
  );
};
